import type React from 'react';
import UntypedLink from '../../components/link';

/** The site's client-side-navigation Link (plain JS), typed for these pages. */
const Link = UntypedLink as unknown as React.ComponentType<
    React.AnchorHTMLAttributes<HTMLAnchorElement> & { to: string }
>;

export default Link;
